import React, { Component } from "react";
import "./style.scss";

export default class FooterComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toShow: false,
      isHome: false
    };
  }

  componentDidMount() {
    let { pathname } = this.props.location;
    if (
      pathname === "/" ||
      pathname === "/contact" ||
      pathname === "/signup" ||
      pathname === "/login"
    ) {
      this.setState({
        toShow: true,
        isHome: true
      });
    }
  }

  handleClose = () => {
    this.setState({
      toShow: !this.state.toShow
    });
  };
  render() {
    let { toShow, isHome } = this.state;
    let searched_url = this.props.location.pathname.split("/")[1];

    return !toShow ? (
      <footer>
        <span
          className={`show_footer ${
            searched_url === "rent-desk" ||
            searched_url === "locations" ||
            searched_url === "dashboard"
              ? "none"
              : ""
          }`}
          onClick={this.handleClose}
        >
          <i className="fa fa-info-circle"></i> Terms, Privacy &amp; More
        </span>
      </footer>
    ) : (
      <footer className={`${isHome ? "home_footer" : ""}`}>
        <div className="footer_top">
          <div className="left">
            <img
              className="logo_footer"
              src="/assets/images/logo-hd-b.png"
              alt="heydesk"
              height="25"
            />

            <div className="social_link">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/heydesk/"
              >
                <img src="/assets/images/social/facebook.svg" alt="facebook" />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.instagram.com/heydesk/?hl=en"
              >
                <img
                  src="/assets/images/social/instagram.svg"
                  alt="instagram"
                />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://in.linkedin.com/company/heydesk"
              >
                <img src="/assets/images/social/linkedin.svg" alt="linkedin" />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://in.pinterest.com/heydeskapp/"
              >
                <img
                  src="/assets/images/social/pinterest.svg"
                  alt="pinterest"
                />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://twitter.com/heydesk"
              >
                <img src="/assets/images/social/twitter.svg" alt="twitter" />
              </a>
            </div>
          </div>
          <div className="right">
            <div className="w-20 f1">
              <h3>Heydesk</h3>
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/">About us</a>
                </li>
                <li>
                  <a href="/contact">Contact us</a>
                </li>
                <li>
                  <a href="/terms">Terms &amp; Conditions</a>
                </li>
                <li>
                  <a href="/terms">Privacy Policy</a>
                </li>
              </ul>
            </div>
            <div className="w-20 f2">
              <h3>Top Cities</h3>
              <ul>
                <li>
                  <a href="/locations/new-york-united-states">New York</a>
                </li>
                <li>
                  <a href="/locations/london-united-kingdom">London</a>
                </li>
                <li>
                  <a href="/locations/copenhagen-denmark">Copenhagen</a>
                </li>
                <li>
                  <a href="/locations/silkeborg-denmark">Silkeborg</a>
                </li>
                <li>
                  <a href="/locations/bengaluru-india">Bengaluru</a>
                </li>
                <li>
                  <a href="/locations/berlin-germany">Berlin</a>
                </li>
              </ul>
            </div>
            <div className="w-20 f3">
              <h3>Top Countries</h3>
              <ul>
                <li>
                  <a href="/locations/united-states">United States</a>
                </li>
                <li>
                  <a href="/locations/denmark">Denmark</a>
                </li>
                <li>
                  <a href="/locations/germany">Germany</a>
                </li>
                <li>
                  <a href="/locations/united-kingdom">United Kingdom</a>
                </li>
                <li>
                  <a href="/locations/italy">Italy</a>
                </li>
                <li>
                  <a href="/locations/canada">Canada</a>
                </li>
              </ul>
            </div>
            <div className="w-40">
              <h3>About us</h3>
              <p>
                HeyDesk with 10,000+ bookings and 211000+ Spaces listed could
                help you find the right space for your requirement. Coworking
                spaces, Shared Office Spaces, Meeting Rooms, Dedicated Desk,
                Venues for your conferences.
              </p>
            </div>
          </div>
        </div>

        <div className="footer_bottom">
          <p>
            © Heydesk {new Date().getFullYear()}. All rights reserved. |{" "}
            <a href="/sitemap">Sitemap</a>
          </p>
        </div>
        <span
          className={`${isHome ? "d-n" : "show_footer"}`}
          onClick={this.handleClose}
        >
          <i className="fa fa-close"></i> Close
        </span>
      </footer>
    );
  }
}
